// Lib
import { simulateTyping } from 'lib/driver';
import { waitForElement } from 'lib/helpers';
import { getRcTreeInstance } from 'lib/thesaurus';

// Actions
import { openModal } from 'reducers/modal';
import * as actionsCreatorSearch from 'pages/Search/reducer';
import * as actionsCreatorProjects from 'pages/Projects/reducer';
import * as actionsCreatorThesaurus from 'pages/Thesaurus/reducer';

const tags = [
	{
		'targetId': 3169,
		'familyId': 631,
		'name': 'Glycine Receptor (All subtypes)',
		'className': 'leaf',
		'navKey': 'key_0_2_1_4_5',
		'key': 'key_1_0_0_0'
	},
	{
		'targetId': 2686,
		'familyId': 631,
		'name': 'glycine receptor &alpha;1 subunit',
		'synonyms': 'glycine receptor subunit alpha-1 | glycine receptor strychnine-binding subunit | B230397M16Rik | glycine receptor, alpha 1 | glycine receptor | STHE | nmf11 | GLYRA1 | glycine receptor, alpha 1 (startle disease/hyperekplexia) | stiff person syndrome | glycine receptor, alpha 1 subunit | ot | oscillator | spd | startle disease/hyperekplexia | glycine receptor 48 kDa subunit',
		'className': 'leaf',
		'navKey': 'key_0_2_1_4_1',
		'key': 'key_1_0_0_1'
	},
	{
		'targetId': 2687,
		'familyId': 631,
		'name': 'glycine receptor &alpha;2 subunit',
		'synonyms': 'glycine receptor subunit alpha-2 | RNNEOGLY | glycine receptor strychnine-binding subunit | GLR | Glycine receptor alpha 2 subunit (glycine receptor, neonatal) | glycine receptor | Glycine receptor alpha 2 subunit (glycine receptor neonatal) | glycine receptor, alpha 2 | glycine receptor, alpha 2 subunit',
		'className': 'leaf',
		'navKey': 'key_0_2_1_4_2',
		'key': 'key_1_0_0_2'
	},
	{
		'targetId': 1493,
		'familyId': 631,
		'name': 'glycine receptor &alpha;3 subunit',
		'synonyms': 'glycine receptor, alpha 3 subunit | glycine receptor | glycine receptor, alpha 3 | glycine receptor subunit alpha-3',
		'className': 'leaf',
		'navKey': 'key_0_2_1_4_0',
		'key': 'key_1_0_0_3'
	},
	{
		'targetId': 3167,
		'familyId': 631,
		'name': 'glycine receptor &alpha;4 subunit <i>(pseudogene in humans)</i>',
		'synonyms': 'similar to Glycine receptor alpha-4 chain precursor | glycine receptor | glycine receptor alpha 4 | glycine receptor, alpha 4 subunit | glycine receptor subunit alpha-4 | glycine receptor, alpha 4 | LOC367912 | RGD1564103',
		'className': 'leaf',
		'navKey': 'key_0_2_1_4_3',
		'key': 'key_1_0_0_4'
	},
	{
		'targetId': 3168,
		'familyId': 631,
		'name': 'glycine receptor &beta; subunit',
		'synonyms': 'glycine receptor, beta subunit | glycine receptor subunit beta | Glycine receptor beta | glycine receptor | spa | Plasmodium falciparum isoleucyl-tRNA synthetase | AI853901 | glycine receptor, beta | glycine receptor 58 kDa subunit',
		'className': 'leaf',
		'navKey': 'key_0_2_1_4_4',
		'key': 'key_1_0_0_5'
	}
];
const checkedKeysBioSearch = [
	'key_1_0_0_0',
	'key_1_0_0_1',
	'key_1_0_0_2',
	'key_1_0_0_3',
	'key_1_0_0_4',
	'key_1_0_0_5'
];
const expandedKeysBioSearch = [
	'key_1',
	'key_1_0',
	'key_1_0_0',
	'key_0_0',
	'key_0_0_0',
	'key_0_1_0',
	'key_0_1_0_0',
	'key_1_0_0',
	'key_1_0_0_0',
	'key_1_0_0_1',
	'key_1_0_0_2',
	'key_1_0_0_3',
	'key_1_0_0_4',
	'key_1_0_0_5',
	'key_2_0_0_0',
	'key_2_0_0_0_1',
	'key_2_0_0_0_2',
	'key_1'
];
export const CONFIG_KEY = 'configTutorial';

export const loadSeenFromLS = (): string[] => {
	try {
		const raw = localStorage.getItem(CONFIG_KEY);
		if (!raw) return [];

		const parsed = JSON.parse(raw);

		// legacy array format: [ 'key1', 'key2' ]
		if (Array.isArray(parsed)) {
			// normalize to map and save back
			const map = parsed.reduce<Record<string, boolean>>((acc, k) => {
				if (typeof k === 'string') acc[k] = true;
				return acc;
			}, {});
			localStorage.setItem(CONFIG_KEY, JSON.stringify(map));
			return parsed.filter(k => typeof k === 'string');
		}

		// object map format: { key1: true, key2: true }
		if (typeof parsed === 'object' && parsed !== null) {
			return Object.keys(parsed).filter(k => !!parsed[k]);
		}

		return [];
	} catch {
		return [];
	}
};

export const saveSeenToLS = (seen: string[]) => {
	try {
		const map = (seen || []).reduce<Record<string, boolean>>((acc, k) => {
			if (k) acc[k] = true;
			return acc;
		}, {});
		localStorage.setItem(CONFIG_KEY, JSON.stringify(map));
	} catch {
	}
};

export const toursConfig = {
	'search-screen': [
		{
			element: '#debounce-input',
			popover: {
				title: 'Step 1',
				description: 'You can type the search keyword here'
			},
			action: async ({ opts, dispatch }: any) => {
				const input = document.querySelector<HTMLInputElement>('#debounce-input');
				if (input && !input?.value) await simulateTyping({
					input: input,
					text: 'adreno'
				});
				dispatch(actionsCreatorSearch.searchText({
					value: (input?.value || '') || 'adreno',
					isHistory: false,
					type: 'update-data'
				}));
				opts.driver.moveNext();
			}
		},
		{
			element: '#button-search',
			popover: {
				title: 'Step 2',
				description: 'Click here to get your search results'
			},
			action: ({ opts }: any) => {
				document.querySelector<HTMLButtonElement>('#button-search')?.click();
			}
		},
		{
			element: '#list-tabs',
			popover: {
				title: 'Step 3',
				description: 'Click on the corresponding section to explore your search results'
			},
			action: ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'search-screen-list': [
		{
			element: '#search-screen-list-id',
			popover: {
				title: 'Step 1',
				description: 'Click to open the compound\'s individual page and explore all details'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#search-screen-list-control',
			popover: {
				title: 'Step 2',
				description: 'Apply filters to choose the project name, preferred prepackage size and number of prepackage units for the compound'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#search-screen-list-add-project',
			popover: {
				title: 'Step 3',
				description: 'Click to add the compound to your project'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'drugs-impurities': [
		{
			element: '#all-drugs-vocabulary-search',
			popover: {
				title: 'Step 1',
				description: 'Use the search function to find your drug of interest'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();

				const targetElement = document.getElementById('all-drugs-vocabulary-list-item');

				if (targetElement) {
					targetElement.scrollIntoView({
						behavior: 'smooth', // for smooth scrolling animation
						block: 'center',     // aligns the element to the top of the visible area
						inline: 'nearest'   // scrolls horizontally to the nearest edge if needed
					});
				}
			}
		},
		{
			element: '#all-drugs-vocabulary-list-item',
			popover: {
				title: 'Step 2',
				description: 'Click to view all details about the drug and its impurities'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();

				const targetElement = document.getElementById('all-drugs-vocabulary-item');

				if (targetElement) {
					targetElement.scrollIntoView({
						behavior: 'smooth', // for smooth scrolling animation
						block: 'center',     // aligns the element to the top of the visible area
						inline: 'nearest'   // scrolls horizontally to the nearest edge if needed
					});
				}
			}
		},
		{
			element: '#all-drugs-vocabulary-item',
			popover: {
				title: 'Step 3',
				description: 'View the number of impurities associated with the selected drug here.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'categorized-products-category': [
		{
			element: '#categorized-products-tree',
			popover: {
				title: 'Step 1',
				description: 'Select the category to see the list of compounds.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'categorized-products-list': [
		{
			element: '#categorized-products-type-view',
			popover: {
				title: 'Step 1',
				description: 'Select the preferred page view'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#categorized-products-package',
			popover: {
				title: 'Step 2',
				description: 'Apply filters to choose the project name and preferred prepackage size for all compounds'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#categorized-products-package-cart-price',
			popover: {
				title: 'Step 3',
				description: 'Click to select the preferred prepackage for individual compounds from the list'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#categorized-products-package-checkbox',
			popover: {
				title: 'Step 4',
				description: 'Select compounds you wish to add to your project'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#categorized-products-package-button',
			popover: {
				title: 'Step 5',
				description: 'Click to add selected compounds to your project'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'bioactive-libraries': [
		{
			element: '#bioactive-libraries-download',
			popover: {
				title: 'Step 1',
				description: 'Download the list of compounds or library information in your preferred format here'
			},
			action: async ({ opts }: any) => {

				opts.driver.moveNext();
			}
		},
		{
			element: '#bioactive-libraries-btn-compound',
			popover: {
				title: 'Step 2',
				description: 'Click to pick compounds from the Library for your Project'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#bioactive-libraries-btn-offer',
			popover: {
				title: 'Step 3',
				description: 'Click to contact the manager regarding the current library'
			},
			action: async ({ opts }: any) => {

				opts.driver.moveNext();
			}
		}
	],
	'chemical-probes': [
		{
			element: '#chemical-probes-search',
			popover: {
				title: 'Step 1',
				description: 'Use the search function to find the compound of interest'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#chemical-probes-filter',
			popover: {
				title: 'Step 2',
				description: 'Apply filters to refine your search results'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#chemical-probes-ebc-id',
			popover: {
				title: 'Step 3',
				description: 'Click to open the compound\'s individual page and explore all details'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#chemical-probes-doi',
			popover: {
				title: 'Step 4',
				description: 'Click to view detailed information about the target'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#chemical-probes-price',
			popover: {
				title: 'Step 5',
				description: 'Click to view pricing and select the preferred prepackage for individual compounds in the list'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#chemical-probes-checkbox',
			popover: {
				title: 'Step 6',
				description: 'Select compounds you wish to add to your project'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#chemical-probes-project',
			popover: {
				title: 'Step 7',
				description: 'Select the project name and add compounds to it'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'drug-individual': [
		{
			element: '#drug-individual-id',
			popover: {
				title: 'Step 1',
				description: 'Click to open the compound\'s individual page and explore all details'
			},
			action: async ({ opts }: any) => {

				opts.driver.moveNext();
			}
		},
		{
			element: '#drug-individual-control',
			popover: {
				title: 'Step 2',
				description: 'Apply filters to choose the project name, preferred prepackage size and number of prepackage units for the compound'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#drug-individual-add-project',
			popover: {
				title: 'Step 3',
				description: 'Click to add the compound to your project'
			},
			action: async ({ opts }: any) => {

				opts.driver.moveNext();
			}
		}
	],
	'header-authorized': [
		{
			element: '#header-authorized-basket',
			popover: {
				title: 'Step 1',
				description: 'Click to create and update your projects'
			},
			action: async ({ opts }: any) => {

				opts.driver.moveNext();
			}
		},
		{
			element: '#header-authorized-avatar',
			popover: {
				title: 'Step 2',
				description: 'Click to check and update your account and project details'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'header-unauthorized': [
		{
			element: '#header-unauthorized-avatar',
			popover: {
				title: 'Step 1',
				description: 'Click here to get all the advances of EBC site - create an account or login with your Enamine Store account credentials'
			},
			action: async ({ opts }: any) => {

				opts.driver.moveNext();
			}
		},
		{
			element: '#header-unauthorized-libraries-products',
			popover: {
				title: 'Step 2',
				description: 'To explore our Bioactive libraries or other products, simply click on the item you\'re interested in'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#header-unauthorized-search-li',
			popover: {
				title: 'Step 3',
				description: 'Click to search for compounds by keywords, CAS number, targets or chemical structure'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#header-unauthorized-services',
			popover: {
				title: 'Step 4',
				description: 'Click here to request your custom compound set or obtain the information you\'re looking for'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'bio-search': [
		{
			element: '#bio-search-debounce-input',
			popover: {
				title: 'Step 1',
				description: 'You can type the search keyword here'
			},
			action: async ({ opts }: any) => {
				const input = document.querySelector<HTMLInputElement>('#bio-search-debounce-input');
				if (input && !input?.value) await simulateTyping({
					input: input,
					text: 'glycine'
				});

				opts.driver.moveNext();
			}
		},
		{
			element: '#bio-search-submit',
			popover: {
				title: 'Step 2',
				description: 'Click here to get your search results'
			},
			action: async ({ opts, dispatch }: any) => {
				dispatch(actionsCreatorThesaurus.handlerChangeInput('glycine'));
				dispatch(actionsCreatorThesaurus.handlerChangeAutoExpand(true));

				dispatch(actionsCreatorSearch.historyList({
					data: 'glycine' || '',
					storeName: 'recentBioSearchList',
					localStoreKey: 'recentBioSearchList'
				}));

				dispatch(actionsCreatorSearch.handlerChangeIsSearch(true));

				const instance = getRcTreeInstance();
				instance?.scrollTo({ key: 'key_2_0_0_0' });

				const el = await waitForElement('.rc-tree-list-scrollbar.rc-tree-list-scrollbar-vertical');
				if (el) {
					opts.driver.moveNext();
				}
			}
		},
		{
			element: '.rc-tree-list-scrollbar.rc-tree-list-scrollbar-vertical',
			popover: {
				title: 'Step 3',
				description: 'Scroll to see all the search results'
			},
			action: async ({ opts }: any) => {
				const getElementById = document.getElementById('bio-search-checkbox');

				if (getElementById) {
					const treeNode = getElementById.closest('.rc-tree-treenode');
					if (treeNode) {
						const checkbox = treeNode.querySelector('.rc-tree-checkbox');
						if (checkbox) {
							(checkbox as HTMLElement).id = 'bio-search-checkbox-target';
						}
					}
				}

				const el = await waitForElement('#bio-search-checkbox-target');

				if (el) {
					opts.driver.moveNext();
				}
			}
		},
		{
			element: '#bio-search-checkbox-target',
			popover: {
				title: 'Step 4',
				description: 'Click the checkbox to choose the targets of interest from the search results'
			},
			action: async ({ opts, dispatch }: any) => {
				dispatch(actionsCreatorThesaurus.handlerUpdateTags(tags));
				dispatch(actionsCreatorThesaurus.handleExpand(expandedKeysBioSearch));
				dispatch(actionsCreatorThesaurus.handlerChangeCheckedGtf(checkedKeysBioSearch));

				opts.driver.moveNext();
			}
		},
		{
			element: '#bio-search-checkbox',
			popover: {
				title: 'Step 5',
				description: 'Click the target name to see all target info'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#bio-search-label',
			popover: {
				title: 'Step 6',
				description: 'Click the target name to see all target info'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},

		{
			element: '#bio-search-target-box-px',
			popover: {
				title: 'Step 7',
				description: 'Type the value of pX to clarify your search results (or default value 4.5 will be used)'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#bio-search-target-box-get-info',
			popover: {
				title: 'Step 8',
				description: 'Click here to get your search results'
			},
			action: async ({ opts, dispatch }: any) => {
				dispatch(actionsCreatorThesaurus.getBaDataForTargets());
				opts.driver.moveNext();
			}
		},
		{
			element: '#bio-search-tabs',
			popover: {
				title: 'Step 9',
				description: 'Click on the corresponding section to explore your search results'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'bio-search-list': [
		{
			element: '#bio-search-list-filter',
			popover: {
				title: 'Step 1',
				description: 'Apply filters to refine your search results'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#cart-bio__uniq-id',
			popover: {
				title: 'Step 2',
				description: 'Click to open the compound\'s individual page and explore all details'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#cart-bio__uniq-id-price',
			popover: {
				title: 'Step 3',
				description: 'Click to view pricing and select the preferred prepackage for individual compounds in the list'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#cart-bio__uniq-id-checkbox',
			popover: {
				title: 'Step 4',
				description: 'Select compounds you wish to add to your project'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#cart-bio__uniq-id-btn',
			popover: {
				title: 'Step 5',
				description: 'Select the project name and add compounds to it'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'structure-search': [
		{
			element: '#structure-search-type',
			popover: {
				title: 'Step 1',
				description: 'Choose the type of search you want to use'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#structure-search-marvin-js',
			popover: {
				title: 'Step 2',
				description: 'Draw the molecule of interest'
			},
			action: async ({ opts, dispatch }: any) => {
				opts.driver.moveNext();

				dispatch(actionsCreatorSearch.updateMarvinStructure('c1ccccc1C(=O)O'));
			}
		},
		{
			element: '#structure-search-checkbox',
			popover: {
				title: 'Step 3',
				description: 'Choose the search criteria'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#structure-search-filter',
			popover: {
				title: 'Step 4',
				description: 'Apply filters to refine your search results (for EBC compounds only)'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#structure-search-search',
			popover: {
				title: 'Step 5',
				description: 'Click here to see the search results'
			},
			action: async ({ opts }: any) => {
				document.querySelector<HTMLButtonElement>('#structure-search-search')?.click();
			}
		}
	],
	'structure-search-list': [
		{
			element: '#structure-search-tabs',
			popover: {
				title: 'Step 1',
				description: 'Choose the type of search you want to use'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#structure-search-id',
			popover: {
				title: 'Step 2',
				description: 'Click to open the compound\'s individual page and explore all details'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#structure-search-control',
			popover: {
				title: 'Step 3',
				description: 'Apply filters to choose the project name, preferred prepackage size and number of prepackage units for the compound'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#structure-search-add-project',
			popover: {
				title: 'Step 4',
				description: 'Click to add the compound to your project'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	],
	'create-project': [
		{
			element: '#projects-add-new-project',
			popover: {
				title: 'Step 1',
				description: 'Click here to create a new project'
			},
			action: async ({ opts, dispatch }: any) => {
				dispatch(openModal({
					type: 'projectAdd'
				}));

				dispatch(actionsCreatorProjects.updateStepTutorial(opts.driver.getActiveIndex()));

				setTimeout(() => {
					opts.driver.moveNext();
				}, 300);
			}
		},
		{
			element: '#projects-modal-add',
			popover: {
				title: 'Step 2',
				description: 'Type your project name and description'
			},
			action: async ({ opts, dispatch }: any) => {
				const inputName = document.querySelector<HTMLInputElement>('#input-projects-name');
				const inputDescription = document.querySelector<HTMLInputElement>('#input-projects-description');

				if (inputName && !inputName?.value) await simulateTyping({
					input: inputName,
					text: 'new_project'
				});

				if (inputDescription && !inputDescription?.value) await simulateTyping({
					input: inputDescription,
					text: 'description'
				});

				dispatch(actionsCreatorProjects.updateStepTutorial(opts.driver.getActiveIndex()));
				opts.driver.moveNext();
			}
		},
		{
			element: '#projects-modal-btn-create',
			popover: {
				title: 'Step 3',
				description: 'Click “Create” for create project'
			},
			action: async ({ opts, dispatch }: any) => {
				document.querySelector<HTMLButtonElement>('#projects-modal-btn-create')?.click();

				dispatch(actionsCreatorProjects.updateStepTutorial(opts.driver.getActiveIndex()));
				opts.driver.moveNext();
			}
		}
	],
	'project': [
		{
			element: '#project-board-add-new-project',
			popover: {
				title: 'Step 1',
				description: 'Click here to add new compound to the project'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#project-board-search',
			popover: {
				title: 'Step 2',
				description: 'Use the search function to find the compound of interest in your projects.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#project-board-tab',
			popover: {
				title: 'Step 3',
				description: 'You can switch between new projects and the history of submitted ones.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#project-board-radio-btn',
			popover: {
				title: 'Step 4',
				description: 'Click here to choose the project to work on.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#project-board-checkbox',
			popover: {
				title: 'Step 5',
				description: 'Select compounds you wish to submit to the checkout.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#project-board-drag-and-drop',
			popover: {
				title: 'Step 6',
				description: 'Drag and drop to change compound’s order in the project.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#project-board-id',
			popover: {
				title: 'Step 7',
				description: 'Click to open the compound\'s individual page and explore all details.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#project-board-checkout',
			popover: {
				title: 'Step 8',
				description: 'Click to submit your order to the manager or to pay for the order directly.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		},
		{
			element: '#project-board-delete-item',
			popover: {
				title: 'Step 9',
				description: 'Click to delete the compound from your project.'
			},
			action: async ({ opts }: any) => {
				opts.driver.moveNext();
			}
		}
	]
};